import React,{useState, useEffect} from "react";
import logo from './logo.svg';
import './App.css';
import Homepage from './Homepage';
import Aboutpage from './Aboutpage';
import Contactpage from './Contactpage';
import Servicepage from './Servicepage';
import Workpage from './Workpage';
import Blogpage from './Blogpage';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./Components/animate.css";
import AuthForm from './Signin';
import ScrollToTop from './Components/ScrollPage';
import TestimonialFilter from './Testimonialfilter';
import AdminPage from './AdminPage';
import ServicePageSingle from './ServicePageSingle';
import ServiceEditPage from './ServiceEditPage';
import GalleryEditPage from './GalleryEditPage';
import OfferPageEdit from './OfferPageEdit';
import CoursePage from './CoursePage';
import ServiceEditPage1 from './ServiceEditPage1';
import Profile from './Profile';
import SEO from './SEO';
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/storage';
import GalleryPage from "./GalleryPage";
import SocialMediaLinksPage from "./SMlinksaddPage";
import CourseEditPage from "./CourseEditPage";
import CoursePagedb from "./CoursesPagedb";
import DemoPage from "./DemoPage";
import Demotheme from "./Demotheme";

const App=()=>{
  
const [metaTitle, setMetaTitle] = useState('');
const [keywords, setKeywords] = useState('');
const [primaryKeywords, setPrimaryKeywords] = useState('');
const [secondaryKeywords, setSecondaryKeywords] = useState('');
const [message3, setMessage3] = useState(''); 


useEffect(() => {
  const metaDataRef = firebase.database().ref('metadata');

  // Fetch metadata from the database
  metaDataRef.once('value').then((snapshot) => {
      const metaData = snapshot.val();
      if (metaData) {
          setMetaTitle(metaData.metaTitle || '');
          setKeywords(metaData.keywords || '');
          setPrimaryKeywords(metaData.primaryKeywords || '');
          setSecondaryKeywords(metaData.secondaryKeywords || '');

      }
  }).catch((error) => {
      console.error('Error fetching metadata:', error);
  });
}, []);

  useEffect(() => {



    const keywordsMeta = document.querySelector('meta[name="keywords"]');
    const primaryKeywordsMeta = document.querySelector('meta[name="primary keywords"]');
    const secondaryKeywordsMeta = document.querySelector('meta[name="secondary keywords"]');

    console.log('Keywords meta content:', keywordsMeta ? keywordsMeta.content : null);
    console.log('Primary keywords meta content:', primaryKeywordsMeta ? primaryKeywordsMeta.content : null);
    console.log('Secondary keywords meta content:', secondaryKeywordsMeta ? secondaryKeywordsMeta.content : null);

    if (keywordsMeta) {
        keywordsMeta.setAttribute('content', keywords);
    }

    if (primaryKeywordsMeta) {
        primaryKeywordsMeta.setAttribute('content', primaryKeywords);
    }

    if (secondaryKeywordsMeta) {
        secondaryKeywordsMeta.setAttribute('content', secondaryKeywords);
    }
}, [metaTitle,keywords, primaryKeywords, secondaryKeywords]);


  return(
    <BrowserRouter>
    <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Homepage/>}/>
        <Route path="/about" element={<Aboutpage/>}/>
        <Route path="/contact" element={<Contactpage/>}/>
        <Route path="/service" element={<Servicepage/>}/>
        <Route path="/work" element={<Workpage/>}/>
        <Route path="/auth" element={<AuthForm/>}/>
        {/* <Route path="/blog" element={<Blogpage/>}/> */}
        <Route path="/testifilter" element={<TestimonialFilter/>}/>
        <Route path="/adminedit" element={<AdminPage/>}/>
        <Route path="/services/:title" element={<ServicePageSingle/>}/>
        <Route path="/courses/:title" element={<CoursePagedb/>}/>
        <Route path="/workedit" element={<ServiceEditPage/>}/>
        <Route path="/galleryedit" element={<GalleryEditPage/>}/>
        {/* <Route path="/offeredit" element={<OfferPageEdit/>}/> */}
        <Route path="/course" element={<CoursePage/>}/>
        <Route path="/serviceedit" element={<ServiceEditPage1/>}/>
        <Route path="/profile" element={<Profile/>}/>
        <Route path="/seo" element={<SEO/>}/>
        <Route path="/gallery" element={<GalleryPage/>}/>
        <Route path="/sociallinks" element={<SocialMediaLinksPage/>}/>
        <Route path="/courseedit" element={<CourseEditPage/>}/>
        <Route path="/demo" element={<DemoPage/>}/>
        <Route path="/demo1" element={<Demotheme/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
